import React from "react";
import { useNavigate } from "react-router-dom";
import { BarChart3, ChevronRight } from "lucide-react";
import { useLang } from "../../hooks/useLang";

const WelcomeSection = ({ userProfile }) => {
  const navigate = useNavigate();
  const { urlLanguage } = useLang();

  const name = (userProfile?.name || "").trim().split(" ")[0] || "there";
  // These used to fall back to "Baku State University" and "Computer Science"
  // for anyone who had not filled them in, which put a stranger's details on
  // their own dashboard. An empty field simply drops out of the line now.
  const detail = [userProfile?.university, userProfile?.major].filter(Boolean).join(" · ");

  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";

  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div className="min-w-0">
        <h1 className="text-2xl font-bold text-foreground">
          {greeting}, {name}
        </h1>
        {detail && <p className="text-sm text-muted-foreground mt-1">{detail}</p>}
      </div>

      <button
        onClick={() => navigate(urlLanguage("/analytics"))}
        className="flex items-center gap-2 px-4 h-10 rounded-xl bg-card border border-border text-sm font-bold text-foreground hover:border-primary hover:text-primary transition-colors cursor-pointer flex-shrink-0"
      >
        <BarChart3 className="w-4 h-4" />
        Full analytics
        <ChevronRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default WelcomeSection;
